import { useEffect } from "react";

const DEFAULT_TITLE = "GYSUMO – Kunst & Poesie von Susanne Monika Gysin";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** Lightweight client-side SEO/meta helper. */
export default function SEO({ title, description, image, type = "website" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · GYSUMO` : DEFAULT_TITLE;
    document.title = fullTitle;
    const url = window.location.href;
    const desc = description || "Digitale Galerie und Poesie von Susanne Monika Gysin.";
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);
    if (image) {
      setMeta("property", "og:image", image);
      setMeta("name", "twitter:image", image);
    }
    setCanonical(url);
  }, [title, description, image, type]);
  return null;
}
